export default "__VITE_ASSET__D5K5UhtN__"